<script>
  import {STAT_INDEXES}               from '../../../../constants/statistics';
  import {sortByMultipleColumnsStore} from '../../../../stores/results/sort-by-multiple-columns-store';
  import {sortKeysStore}              from '../../../../stores/results/sort-keys-store';

  export let rowspan;
  export let statName;

  const displayName = statName.replace('Speed, ', '').replace('Handling, ', '');

  const statIndex = STAT_INDEXES[statName];

  $: sortClass = $sortKeysStore.includes(statIndex) ? 'sort-active' : '';

  const onClick = (event) => {
    if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey || $sortByMultipleColumnsStore) {
      sortKeysStore.append(statIndex);
    } else {
      sortKeysStore.replace(statIndex);
    }
  };
</script>

<style>
  .results-col-score {
    font-size: 12px;
    height: 44px;
    min-width: 27px; /* maintain table width on narrow screens */
    vertical-align: top;
    word-break: break-word;
  }

  .sort {
    cursor: pointer;
    position: relative;
  }

  .sort:hover {
    color: #2498f2;
  }

  .sort-arrow {
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-top: 7px solid #333;
    display: none;
  }

  .sort-active .sort-arrow {
    display: inline-block;
  }

  .sort-active:hover .sort-arrow {
    border-top: 7px solid #2498f2;
  }
</style>

<template lang="pug" src="./th-sortable.pug"></template>
